import { Badge, type BadgeProps } from "../ui/badge.js";

// HR's verification call on an emergency contact. Shown to HR (profile) and,
// read-only, to the employee (wizard step 4).
const CONTACT_VERIFICATION: Record<string, { label: string; tone: BadgeProps["tone"] }> = {
  PENDING:     { label: "Verification pending", tone: "neutral" },
  VERIFIED:    { label: "Verified", tone: "success" },
  UNREACHABLE: { label: "Unreachable", tone: "warning" },
  FAILED:      { label: "Verification failed", tone: "error" },
};

export function ContactVerificationBadge({ status }: { status: string | null | undefined }) {
  const s = CONTACT_VERIFICATION[status ?? "PENDING"] ?? CONTACT_VERIFICATION["PENDING"]!;
  return <Badge tone={s.tone}>{s.label}</Badge>;
}
